

class Point3D
{


    constructor(x, y, z)
    {
        this.x = x;
        this.y = y;
        this.z = z;
    }


    add(pt3d)
    {
        return new Point3D(this.x + pt3d.x, this.y + pt3d.y, this.z + pt3d.z)
    }


    subtract(pt3d)
    {
        return new Point3D(this.x - pt3d.x, this.y - pt3d.y, this.z - pt3d.z)
    }


    moveTowards(targetVector, rate)
    {
        this.x = this.x + (targetVector.x - this.x) * rate;
        this.y = this.y + (targetVector.y - this.y) * rate;
        this.z = this.z + (targetVector.z - this.z) * rate;
    }


    dotProduct(pt3d)
    {
        return this.x * pt3d.x + this.y * pt3d.y + this.z * pt3d.z;
    }


    scale(k)
    {
        this.x *= k;
        this.y *= k;
        this.z *= k;
    }


    vectorScale(pt3d)
    {
        this.x *= pt3d.x;
        this.y *= pt3d.y;
        this.z *= pt3d.z;
    }


    distance(pt3d)
    {
        let dX = this.x - pt3d.x;
        let dY = this.y - pt3d.y;
        let dZ = this.z - pt3d.z;

        return Math.sqrt(dX*dX + dY*dY + dZ*dZ);
    }


    toString()
    {
        return "(" + this.x + "," + this.y + "," + this.z + ")";
    }


    normalize()
    {
        let d = this.getLength();
        this.scale(1/d);
    }


    /**
     *
     * @returns {Point3D}
     */
    clone()
    {
        return new Point3D(this.x, this.y, this.z);
    }


    getLength()
    {
        return this.distance(new Point3D(0,0,0));
    }


}


export default Point3D;